import { userStore } from '../stores';

class UserApiService {

  getBalance = async (): Promise<number | null> => {
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/Users/Balance`, {
      headers: {
        'Authorization': `Bearer ${userStore.accessToken}`,
      }
    });
    if (response.ok) {
      const responseData = await response.json();
      return responseData.data.realBalance;
    }

    return null;
  }

}

export const userApiService = new UserApiService();
